import React, { useState } from "react";
import { ColorPicker, useColor } from "react-color-palette";
import SingleColor from "./SingleColor";
import "react-color-palette/lib/css/styles.css";
import Values from "values.js";

// const color = new Values("hsl(204deg 100% 50% / 1)"),
//   { log } = console;

// console.log(color);

function App() {
  // const [color, setColor] = useState("");
  const [error, setError] = useState(false);
  const [weigth, setWeigth] = useState(10);
  const [list, setList] = useState(new Values("#ffa500").all(weigth));
  const [color, setColor] = useColor("hex", "#ffa500");
  console.log(color.hex);
  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      setError(false);
      let colors = new Values(color.hex).all(weigth);

      setList(colors);
    } catch (error) {
      setError(true);
      console.log(error);
    }
  };
  return (
    <>
      <section className="container">
        <h2>Color generator</h2>

        <ColorPicker
          width={320}
          height={228}
          color={color}
          onChange={setColor}
          hideHSV
          hideRGB
          dark
        />
        <div className="input-picker-container">
          <label>Peso Gamma colori</label>
          <input
            min="0"
            max="100"
            type="number"
            value={weigth}
            onChange={(e) => {
              if (e.target.value >= 1) {
                setWeigth(parseInt(e.target.value));
              } else {
                setWeigth(1);
              }
            }}
          ></input>
        </div>
        <button className="btn" onClick={handleSubmit}>
          Generate
        </button>
      </section>
      <section className="colors">
        {list.map((color, index) => {
          return (
            <SingleColor
              {...color}
              length={list.length}
              key={index}
              index={index}
            />
          );
        })}
      </section>
    </>
  );
}

export default App;
